import React from "react";

const AdminView = () => null;

export default AdminView;
